import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UnitParsePipe} from './unit-parse.pipe';

@NgModule({
  declarations: [UnitParsePipe],
  exports: [UnitParsePipe],
  imports: [
    CommonModule
  ],
  providers: [UnitParsePipe]
})
export class UnitParseModule { }
